/**
 * Asks the browser to keep the local database from being evicted. Resolves to whether storage is
 * persistent; false when the browser refused or does not support the request.
 */
export async function requestPersistence(): Promise<boolean> {
  try {
    if (typeof navigator === 'undefined' || navigator.storage === undefined) return false;
    if (typeof navigator.storage.persisted === 'function' && (await navigator.storage.persisted()))
      return true;
    return await navigator.storage.persist();
  } catch {
    return false;
  }
}
